<template>
    <div>
        <v-dialog v-model="dialog" width="500" persistent>
            <v-card v-if="type == 'selfie' && !bandCropper" class="mx-auto">
                <v-card-text style="padding: 12px; margin: 0 auto; display: flex;">
                    <div v-if="!showCam">
                        <WarningAlert>
                            {{ $t('profile.web_cam.error.title') }}
                        </WarningAlert>
                        <p class="black--text">{{ $t('profile.web_cam.error.text_1') }}</p>
                        <p class="black--text">{{ $t('profile.web_cam.error.text_2') }}</p>
                    </div>
                    <video ref="webcam" v-if="showCam" width="360" height="380"
                        style="max-width: 100%; border: 1px #000 solid; margin: 0 auto;" autoplay playsinline></video>
                    <canvas ref="webcam_canvas" data-type="profile" width="360" height="480"
                        style="border: 1px #000 solid; display: none;"></canvas>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue-grey" class="ma-2 white--text" @click="close">{{ $t("profile.cancel")
                    }}</v-btn>
                    <v-btn color="blue-grey" class="ma-2 white--text" @click="submitSelfie">{{ $t("profile.take-selfie")
                    }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <input ref="input" type="file" name="image" accept="image/*" @change="setImage" />

        <div class="content"></div>
    </div>
</template>
  
<script>
import {
    VBtn, VCard, VCardText, VDialog, VCardActions, VSpacer, VDivider
} from 'vuetify/lib';
import WarningAlert from '@/components/alert/WarningAlert.vue';

export default {
    components: {
        VBtn, VCard, VCardText, VDialog, VCardActions, VSpacer, VDivider,
        WarningAlert
    },
    props: {
        participantId: { type: Number, default: 0 },
        buttonColor: String,
        type: { type: String, default: 'avatar' },
    },
    data() {
        return {
            dialog: false,
            imgSrc: null,
            cropImg: '',
            data: null,
            bandCropper: false,
            showCam: false,
            cropperOptions: {},
            mediaStream: null,
            bandClose: false
        };
    },
    methods: {
        save() {
            if (this.imgSrc) {
                ///this.cropImage();
                this.$emit('uploadCropperImage', {
                    userId: this.participantId,
                    base64Image: this.imgSrc,
                    fileName: `avatarFor${this.participantId}`
                });
                if (this.type != 'avatar') {
                    this.dialog = false;
                    setTimeout(() => { this.imgSrc = null; }, 500);
                    this.cropImg = null;
                    this.data = null;
                }
            } else {
                this.close();
            }
        },
        open() {
            //this.dialog = true;
            this.bandCropper = true;
            this.showFileChooser();
        },
        close() {
            this.bandClose = true;
            this.closeCam();
            this.dialog = false;
            setTimeout(() => { this.imgSrc = null; }, 500);
            this.cropImg = null;
            this.data = null;
        },
        cropImage() {
            // get image data for post processing, e.g. upload or setting image src
            this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
        },
        flipX() {
            const dom = this.$refs.flipX;
            let scale = dom.getAttribute('data-scale');
            scale = scale ? -scale : -1;
            this.$refs.cropper.scaleX(scale);
            dom.setAttribute('data-scale', scale);
        },
        flipY() {
            const dom = this.$refs.flipY;
            let scale = dom.getAttribute('data-scale');
            scale = scale ? -scale : -1;
            this.$refs.cropper.scaleY(scale);
            dom.setAttribute('data-scale', scale);
        },
        getCropBoxData() {
            this.data = JSON.stringify(this.$refs.cropper.getCropBoxData(), null, 4);
        },
        getData() {
            this.data = JSON.stringify(this.$refs.cropper.getData(), null, 4);
        },
        move(offsetX, offsetY) {
            this.$refs.cropper.move(offsetX, offsetY);
        },
        reset() {
            this.$refs.cropper.reset();
        },
        rotate(deg) {
            this.$refs.cropper.rotate(deg);
        },
        setCropBoxData() {
            if (!this.data) return;

            this.$refs.cropper.setCropBoxData(JSON.parse(this.data));
        },
        setData() {
            if (!this.data) return;

            this.$refs.cropper.setData(JSON.parse(this.data));
        },
        setImage(e) {
            const file = e.target.files[0];

            if (!file || (file && file.type.indexOf('image/') === -1)) {
                return;
            }
            //this.dialog = true;
            setTimeout(() => {
                if (typeof FileReader === 'function') {
                    const reader = new FileReader();

                    reader.onload = (event) => {
                        this.imgSrc = event.target.result;
                        // rebuild cropperjs with the updated source
                        this.save();
                        /*setTimeout(() => {
                            this.$refs.cropper.replace(event.target.result);
                        }, 300);*/
                    };

                    reader.readAsDataURL(file);
                } else {
                    //alert('Sorry, FileReader API not supported');
                }
                //this.cropperIntuitive();
            }, 200);
        },
        showFileChooser() {
            this.$refs.input.click();
        },
        zoom(percent) {
            this.$refs.cropper.relativeZoom(percent);
        },
        closeCam() {
            let video = this.$refs.webcam;
            if (video) {
                video.pause();
            }
            if (this.mediaStream) {
                this.mediaStream.getVideoTracks()[0].stop();
            }
            return video;
        },
        //For Selfie
        openSelfie() {
            this.dialog = true;
            this.bandCropper = false;
            this.showCam = true;
            setTimeout(() => {
                this.$nextTick(async () => {
                    var vidobj = this.$refs.webcam;
                    const parent = this;

                    try {
                        const devices = await navigator.mediaDevices.enumerateDevices();
                        const videoDevices = devices.filter(device => device.kind === 'videoinput');

                        if (videoDevices.length > 0) {
                            /*const constraints = { video: true/*{ deviceId: videoDevices[0].deviceId }*//* };*/
                            const stream = await navigator.mediaDevices.getUserMedia({ video: true });
                            // La cámara está disponible y no está siendo ocupada por otra aplicación
                            this.mediaStream = stream;
                            vidobj.srcObject = stream;
                            vidobj.play();
                            //stream.getTracks().forEach(track => track.stop());
                        } else {
                            parent.showCam = false;
                        }
                    } catch {
                        // Error al acceder a la cámara de video
                        parent.showCam = false;
                    }
                    //TEST CODE
                    /*let vidobj = this.$refs.webcam;
                    navigator.mediaDevices.getUserMedia({ video: true }).then((stream) => {
                        vidobj.srcObject = stream;
                        vidobj.play();
                    });*/     
                });
            },500);
            
        },
        submitSelfie() {
            if (this.showCam) {
                var canvas = this.$refs.webcam_canvas;
                canvas.width = 360;
                canvas.height = 480;
                var ctx = canvas.getContext('2d');
                let video = this.$refs.webcam;
                //draw image to canvas. scale to target dimensions
                ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

                //convert to desired file format
                var dataURI = canvas.toDataURL('image/jpeg'); // can also use 'image/png'

                this.uploadSelfie(dataURI);

                this.closeCam();
                //video.play();
            } else {
                this.dialog = false;
            }
        },
        uploadSelfie(dataURI) {
            //this.bandCropper = true;
            this.imgSrc = dataURI;
            // rebuild cropperjs with the updated source
            setTimeout(() => {
                this.save();
            }, 500);

        },
        testSetting() {
            setTimeout(() => { this.$refs.cropper.setData({ x: 30, y: 30, width: 360, height: 380, top: 0 }); }, 500);
        },
        getCroppedImage() {
            // Get a reference to the cropper component
            const cropper = this.$refs.cropper;

            // Use the setData() method to change the position of the image
            cropper.setData({
                x: 100, // Set the new x position
                y: 100, // Set the new y position
            });

            // Get the cropped canvas with the changed position
            const croppedCanvas = cropper.getCroppedCanvas();

            // Do something with the cropped canvas, such as displaying it on the page or saving it
            // For example, you can create an image element and set its src to the cropped canvas data
            const croppedImageElement = document.createElement('img');
            croppedImageElement.src = croppedCanvas.toDataURL(); // Display the cropped image on the page
            document.body.appendChild(croppedImageElement); // Append the image to the body
        },
        cropperIntuitive(time = 500) {
            setTimeout(() => {
                this.$refs.cropper.setCropBoxData({ top: 17, left: 17, width: 250 });
                this.$refs.cropper.setDragMode('move');
                let heightImg = 0;
                let cropper = document.getElementsByClassName('cropper-container');
                heightImg = cropper.length > 0 ? cropper[0].offsetHeight : 0;
                let scrollHeight = -1 * ((heightImg - 180) / 2);
                if (scrollHeight < 0) {
                    //this.$refs.cropper.move(0, scrollHeight);
                }
                if (cropper.length > 0) {
                    //cropper[0].style.maxHeight = '180px';
                }
            }, time);
        }
    },
    mounted() { },
    watch: {
        dialog(val) {
            if (!val && this.bandClose) {
                this.close();
                this.bandClose = false;
            }
        }
    }
};
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
body {
    font-family: Arial, Helvetica, sans-serif;
    /*width: 1024px;*/
    margin: 0 auto;
}

input[type="file"] {
    display: none;
}

.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0 5px 0;
}

.header h2 {
    margin: 0;
}

.header a {
    text-decoration: none;
    color: black;
}

.content {
    display: flex;
    justify-content: space-between;
}

.cropper-area {
    width: 614px;
}

.actions {
    margin-top: 1rem;
}

.actions a {
    display: inline-block;
    padding: 5px 15px;
    background: #0062CC;
    color: white;
    text-decoration: none;
    border-radius: 3px;
    margin-right: 1rem;
    margin-bottom: 1rem;
}

textarea {
    width: 100%;
    height: 100px;
}

.preview-area {
    width: 307px;
}

.preview-area p {
    font-size: 1.25rem;
    margin: 0;
    margin-bottom: 1rem;
}

.preview-area p:last-of-type {
    margin-top: 1rem;
}

.preview {
    width: 100%;
    height: calc(372px * (9 / 16));
    overflow: hidden;
}

.crop-placeholder {
    width: 100%;
    height: 200px;
    background: #ccc;
}

.cropped-image img {
    max-width: 100%;
}

.errorImg .v-alert__border {
    display: none;
}
</style>